import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';

type State = {
  ids: string[];
};

type Actions = {
  getIds(): string[];
  setIds(value: string[]): void;
  reset(): void;
};

const INITIAL_STATE = {
  ids: [],
};

export const useCopyPasteStore = create<State & Actions>()(
  devtools(
    (set, get) => ({
      ...INITIAL_STATE,

      getIds() {
        return get().ids;
      },

      setIds(ids) {
        set(() => ({ ids }), undefined, {
          type: 'setIds',
        });
      },

      reset: () => {
        set(INITIAL_STATE, undefined, {
          type: 'reset',
        });
      },
    }),

    { store: 'copyPasteStore', ...DEVTOOLS_OPTIONS },
  ),
);
